export default __webpack_public_path__ + "static/media/sixtema.0d2323b5.png";